import React from "react";
import { Link } from "react-router-dom";
import logoFooter from "../../pages/assets/LogoSofaF.png";
import "./Footer.css";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <img
              src={logoFooter}
              alt={t("footer.brandAlt")}
              className="footer__logo"
            />

            <p className="footer__tagline">{t("footer.tagline")}</p>

            <div className="footer__socials" aria-label={t("footer.socialsAria")}>
              <a
                href="https://facebook.com/sofa.factory.cr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.social.facebook")}
                className="social-icon"
              >
                <i className="fab fa-facebook-f"></i>
              </a>

              <a
                href="https://www.instagram.com/thesofafactory.cr/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.social.instagram")}
                className="social-icon"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>

          </div>

          <div className="footer__grid">
            {/* Productos */}
            <div className="footer__col">
              <h4 className="footer__title">{t("footer.productsTitle")}</h4>
              <ul className="footer__list">
                <li>
                  <Link to="/" className="footer__link">
                    {t("footer.products.items.sofaFactory")}
                  </Link>
                </li>
                <li>
                  <Link to="https://rollerup.gruposantamaria.cr/" className="footer__link">
                    {t("footer.products.items.rollerUp")}
                  </Link>
                </li>
                <li>
                  <Link to="https://dreamon.gruposantamaria.cr/" className="footer__link">
                    {t("footer.products.items.dreamOn")}
                  </Link>
                </li>
                <li>
                  <Link to="https://deko.gruposantamaria.cr/" className="footer__link">
                    {t("footer.products.items.deko")}
                  </Link>
                </li>
                <li>
                  <Link to="https://textiles.gruposantamaria.cr/" className="footer__link">
                    {t("footer.products.items.textiles")}
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contacto */}
            <div className="footer__col">
              <h4 className="footer__title">{t("footer.contactTitle")}</h4>
              <ul className="footer__list">
                <li className="footer__contact-item">
                  <i className="fas fa-envelope" aria-hidden="true"></i>{" "}
                  {t("footer.contact.email")}
                </li>
                <li className="footer__contact-item">
                  <i className="fas fa-phone-alt" aria-hidden="true"></i>{" "}
                  {t("footer.contact.phone")}
                </li>
                <li className="footer__contact-item">
                  <i className="fas fa-map-marker-alt" aria-hidden="true"></i>{" "}
                  {t("footer.contact.country")}
                </li>
              </ul>
            </div>

            {/* Showrooms */}
            <div className="footer__col">
              <h4 className="footer__title">{t("footer.showroomsTitle")}</h4>
              <ul className="footer__list">
                {t("footer.showrooms", { returnObjects: true }).map((s, idx) => (
                  <li key={idx}>{s}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            {t("footer.copyright", { year: currentYear })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
